module.exports = __webpack_public_path__ + "images/landing/video-previews/Whiteboard_short_explainer_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Whiteboard_short_explainer_2x.jpg
// module id = R2Pv
// module chunks = 1